// extracted by mini-css-extract-plugin
export var container = "_ep-0";
export var icon = "_ep-1";
export var text = "_ep-2";